import { render, staticRenderFns } from "./DisplayHO215Data.vue?vue&type=template&id=1fbe286d"
import script from "./DisplayHO215Data.vue?vue&type=script&lang=ts"
export * from "./DisplayHO215Data.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports